import { AssetFieldsFragment } from "@src/generated/graphql";
import Typography from "./Typography";
import DynamicLink from "./DynamicLink";
import { FaArrowRightLong } from "react-icons/fa6";
import { useEffect, useState } from "react";

type GridBlockProps = {
  image?: AssetFieldsFragment | string;
  title?: string;
  description?: string;
  link?: string;
  linkText?: string;
  typographyClassName?: string;
  tag?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  isOverLay?: boolean;
  className?: string;
  image2?: AssetFieldsFragment | string;
  subDescription?: string;
  icon?: AssetFieldsFragment | string;
  isFirstCard?: boolean;
};

const GridBlock = ({
  image,
  title,
  description,
  link,
  linkText = "Learn more",
  typographyClassName,
  tag = "h6",
  isOverLay = false,
  className,
  image2,
  subDescription,
  icon,
  isFirstCard,
}: GridBlockProps) => {
  const [isMobile, setIsMobile] = useState(false);
 
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    checkMobile();

    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return (
    <div
    className="grid-block-main-item card-animate"
    style={{
      maxWidth: isMobile ? "100%" : isFirstCard ? "60%" : "45%",
    }}
  >
    {isOverLay && image && (
      <div
        className="box-overlay-gradient card-animate__media"
        style={{
          height: "250px",
          position: "relative",
          overflow: "hidden"
        }}
      >
        <img
           src={(image as AssetFieldsFragment)?.url ?? ""}
           alt={(image as AssetFieldsFragment)?.title ?? ""}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: "8px",
            display: "block"
          }}
        />

        {icon && (
          <div
            className="position-absolute card-animate__icon"
            style={{
              bottom: "-10px",
              left: isMobile ? "15%" : isFirstCard ? "5px" : "5px",
              transform: "translateX(-50%)",
              zIndex: 100
            }}
          >
            <img
               src={(icon as AssetFieldsFragment)?.url ?? ""}
               alt={(icon as AssetFieldsFragment)?.title ?? ""}
              style={{
                maxWidth: "80%",
                height: "auto"
              }}
            />
          </div>
        )}
      </div>
    )}

    <div
      className="grid-block-content card-animate__content"
      style={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        padding: "15px 15px",
        position: "relative"
      }}
    >
      <div className="card-animate__text-content">
        {title && (
          <Typography
            tag={tag}
            className="grid-title card-animate__title font-medium"
          >
            {title}
          </Typography>
        )}
        {description && (
          <p className="mb-0 card-animate__description" style={{color:"#131327"}}>{description}</p>
        )}
        {subDescription && (
          <p className="mb-0 card-animate__description" style={{color:"#131327"}}>{subDescription}</p>
        )}
      </div>

      <div className="card-animate__link">
        <DynamicLink url={link} className="btn-default-bdr">
          <span>{linkText}</span>
          <FaArrowRightLong className="btn-icon" />
        </DynamicLink>
      </div>
    </div>
  </div>
  );
};

export default GridBlock;
